export default "<span class=\"botao-pilula d-inline-block\">\r\n  {{ texto }}\r\n</span>\r\n"